import React from 'react';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';

class DateTimePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            focused:false,
        }

        this.handleDateChange = this.handleDateChange.bind(this);
        this.hours = this.hours.bind(this);
    }

    handleDateChange(d) {
        let date = d.hour(this.props.date.hour()).minute(this.props.date.minute());
        this.pushChange(date);
    }

    pushChange = (date) => {
        this.props.handleDateChange(date);
    }

    hours() {
        let ret = [];

        for(let i=0;i<=23;i++) {
            if(i.toString().length == 1) {
                i = '0'+i.toString();
            }
            ret.push(<option key={i} value={i}>{i}</option>);
        }

        return ret;
    }

    handleCheckChange = (e) => {
        this.props.handleCheckChange(!this.props.isChecked);
    }

    handleHourChange = (e) => {
        let date = moment(this.props.date).hour(e.target.value).second(0);
        this.pushChange(date);
    }

    handleMinuteChange = (e) => {
        let date = moment(this.props.date).minute(e.target.value).second(0);
        this.pushChange(date);
    }

    getHourFromDate = () => {
        return this.props.date.hour();
    }
    getMinuteFromDate = () => {
        return this.props.date.minute();
    }

    render() {
        return (
            <div>
                <div className="col-sm-6">
                    <SingleDatePicker
                        disabled={!this.props.isChecked}
                        displayFormat={'MMMM Do YYYY'}
                        small={true}
                        block={true}
                        date={this.props.date}
                        onDateChange={this.handleDateChange}
                        focused={this.state.focused}
                        onFocusChange={({ focused }) => this.setState({ focused })}
                    />
                </div>

                <div className="col-sm-6">
                    <table style={{width:'100%'}}>
                        <tbody>
                            <tr>
                                <td>
                                    <select className="form-control input-lg" value={this.getHourFromDate()} onChange={this.handleHourChange} disabled={!this.props.isChecked}>
                                        {this.hours()}
                                    </select>
                                </td>
                                <td>
                                    &nbsp;:
                                </td>
                                <td>
                                    <select className="form-control input-lg" value={this.getMinuteFromDate()} onChange={this.handleMinuteChange} disabled={!this.props.isChecked}>
                                        <option value="00">00</option>
                                        <option value="15">15</option>
                                        <option value="30">30</option>
                                        <option value="45">45</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>





            </div>
        );
    }


}

export default DateTimePicker;




// WEBPACK FOOTER //
// ./components/widgets/DateTimePicker.js